export enum MixpanelPeopleProperties {
  NAME = 'name',
  EMAIL = 'email',
  CREATED_AT = 'createdAt',
  CHILDREN = 'children',
  EXECUTORS = 'executors',
  BENEFICIARIES = 'beneficiaries',
  FREE_WILL_STARTED = 'freeWillStarted',
  MARITAL_STATUS = 'maritalStatus',
  CITY = 'city',
  STATE_PROVINCE = 'stateProvince',
  COUNTRY = 'country',
  AGE = 'age',
  PLAN_PURCHASED = 'planPurchased',
  PLAN_SELECTED = 'planSelected',
  FREE_WILL_GENERATED = 'freeWillGenerated',
  INDIVIDUAL_TITLE = 'individualTitle'
}
